import Service from '../Service'
import {http} from '../config'

export default class OportunidadeService extends Service{

    constructor(){
        super('oportunidade');
    }
    
    EnviarDocumento(oportunidadeId, nome, arquivo, versao){
        let bodyFormData = new FormData();
        bodyFormData.append('arquivo', new Blob([arquivo], { type: 'application/pdf' }));

        return http.post(`${this.getNomeControle()}/${oportunidadeId}/documento`, bodyFormData, {
            headers: {'Content-Type': 'multipart/form-data' },
            params: {
                nome: nome,
                versao
            }
        });
    }

    DeletarDocumento(oportunidadeId, nome, versao){
        return http.delete(`${this.getNomeControle()}/${oportunidadeId}/documento`, {
            params: {
                nome: nome,
                versao
            }
        });
    }

    DownloadDocumento(oportunidadeId, nome){
        return http.get(`${this.getNomeControle()}/${oportunidadeId}/documento`, {
            responseType: 'blob',
            params: {
                nome: nome
            }
        }).then(res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nome);
            document.body.appendChild(link);
            link.click();
        });
    }

    CRM(fonteId, incentivoId, statusId){
        return http.get(`${this.getNomeControle()}/crm`, {
            params: {
                fonteId,
                incentivoId,
                statusId
            }
        });
    }

    Painel(filtro = {}) {
        return http.get(`${this.getNomeControle()}/painel`, { params: filtro });
    }

    Responsaveis() {
        return http.get(`${this.getNomeControle()}/responsaveis`);
    }

    MoverEtapa(id, modelo) {
        return http.put(`${this.getNomeControle()}/${id}/etapa`, modelo);
    }

    ListarAtividades(filtro = {}) {
        return http.get(`${this.getNomeControle()}/atividades`, { params: filtro });
    }

    SalvarAtividade(modelo) {
        const url = `${this.getNomeControle()}/atividades`;
        return modelo.id > 0 ? http.put(`${url}/${modelo.id}`, modelo) : http.post(url, modelo);
    }

    Historico(id) {
        return http.get(`${this.getNomeControle()}/${id}/historico`);
    }

    AdicionarObservacao(id, descricao) {
        return http.post(`${this.getNomeControle()}/${id}/historico`, { descricao });
    }

    ResumoDoador(id) {
        return http.get(`${this.getNomeControle()}/doador/${id}/resumo`);
    }

  }
